// Generates a random avatar background color, per login, that always passes
// WCAG AA contrast (>=6:1) against the white initials text drawn on top of
// it. Contrast is a property of the circle's own background vs. its text, so
// the result reads correctly regardless of the surrounding page being in
// light or dark mode.

function hslToRgb(h, s, l) {
  s /= 100; l /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [255 * f(0), 255 * f(8), 255 * f(4)];
}

function relativeLuminance(r, g, b) {
  const [rs, gs, bs] = [r, g, b].map(c => {
    c /= 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

function contrastRatio(lumA, lumB) {
  const lighter = Math.max(lumA, lumB);
  const darker  = Math.min(lumA, lumB);
  return (lighter + 0.05) / (darker + 0.05);
}

// Picks a random hue/saturation, then binary-searches for the lightest
// lightness value that still keeps contrast against white text >= 6:1.
export function generateAvatarColor() {
  const hue = Math.floor(Math.random() * 360);
  const sat = 55 + Math.random() * 25; // 55-80%, keeps colors vivid but not neon

  let lo = 0, hi = 100, best = 25;
  for (let i = 0; i < 20; i++) {
    const mid = (lo + hi) / 2;
    const [r, g, b] = hslToRgb(hue, sat, mid);
    const ratio = contrastRatio(1, relativeLuminance(r, g, b)); // 1 = white text luminance
    if (ratio >= 6.15) { best = mid; lo = mid; } else { hi = mid; }
  }
  return `hsl(${hue}, ${sat.toFixed(0)}%, ${best.toFixed(0)}%)`;
}

// Deterministic variant: the same name always gets the same colour (used for
// per-person initials chips), still >= 6:1 against white text.
export function avatarColorForName(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  const hue = hash % 360;
  let lo = 0, hi = 100, best = 25;
  for (let i = 0; i < 20; i++) {
    const mid = (lo + hi) / 2;
    const [r, g, b] = hslToRgb(hue, 62, mid);
    if (contrastRatio(1, relativeLuminance(r, g, b)) >= 6.15) { best = mid; lo = mid; } else { hi = mid; }
  }
  return `hsl(${hue}, 62%, ${best.toFixed(0)}%)`;
}
